import '@babel/polyfill';
import React from 'react';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'url-search-params-polyfill';
import Root from './components/root';
import * as serviceWorker from './serviceWorker';
import { store } from './store';

const controller = process.env.REACT_APP_SPA_ROOT || '';
const pathName = window.location.pathname.toLocaleLowerCase();
const spaPath = pathName.substring(
    0,
    pathName.indexOf(controller) + controller.length
);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <Root />
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
